import React, { Fragment, useState, useEffect } from "react";
import { styled, withStyle } from "baseui";
import { MAIN_SIDEBAR_ITEMS } from "../../constants/AppEnums";
import ModelerExecuteSidebarView from "./ModelerExecuteSidebarView";
import ModelerHistorySummary from "./ModelerHistorySummary";
import ModelerExecuteHomeView from "./ModelerExecuteHomeView";
import ModelerRunExecutions from "./ModelerRunExecutions";
import ROUTES_PATH from "../../constants/RouteConstants";
import ModelerSubHeaderView from "./ModelerSubHeaderView";
import * as AppConstants from "../../constants/AppConstants";
import { fetchModelerById } from "../../redux/modeler/ModelerThunk";
import {
  createNewModelRun,
  fetchModelRunById,
  createModelRunAsset,
} from "../../redux/model-run/ModelRunThunk";
import { connect } from "react-redux";
import { Button } from "baseui/button";
import Plus from "baseui/icon/plus";
import ModelerDocumentationView from "./ModelerDocumentationView";
import {
  resetModelRunState,
  setselectedModelRun,
} from "../../redux/model-run/ModelRunActions";
import { useHistory, useParams, useLocation } from "react-router-dom";
import UploadModalComponent from "../../components/upload-modal/UploadModalComponent";
import { Route } from "react-router-dom";
import useToaster from "../../hooks/useToaster";
import { ExtraLargeSpinner } from "../../components/styled-components/StyledComponents";
import SubHeader from "../../components/sub-header/SubHeader";
import FetchErrorComponent from "../../components/fetch-error/FetchErrorComponent";
import { Grid, Cell } from "baseui/layout-grid";
import useRouteParams from "../../hooks/useRouteParams";
import * as GLOBAL_CONSTANTS from "../../constants/GlobalConstants";
import { Block } from "baseui/block";
import { LabelMedium, ParagraphMedium } from "baseui/typography";
import ModelerPropertiesAsideView from "./ModelerPropertiesAsideView";
import  ModelerPostProcessingView  from "./ModelerPostProcessingView";
import ModelerReportsView from "./ModelerReportsView";
import {Notification, KIND} from "baseui/notification";
const MainContainer = styled(Grid, ({ $theme }) => ({
  margin: "auto auto",
  padding: AppConstants.APP_MAIN_PADDING,
}));

const MainArea = styled(Cell, ({ $theme }) => ({
  display: "flex",
  width: "100%",
  padding: "5px 70px 30px 30px",
  overflowY: "scroll",
  height: AppConstants.APP_GLOBAL_HEIGHT,
}));

const SidebarArea = styled(Cell, ({ $theme }) => ({
  borderRight: "2px solid",
}));

const AsideArea = styled(Cell, ({ $theme }) => ({
  borderRight: "2px solid",
}));
const MessageContainer = styled("div", ({ $theme }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
}));

function ModelerExecuteView(props) {
  const { modelerId } = useParams();
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
  const { pathParams, searchParams, searchPart } = useRouteParams();
  const history = useHistory();
  const [activeItemId, setActiveItemId] = useState(
    ROUTES_PATH.modelerExecuteHome
  );
  useToaster(props.updateErrorMessage);
  useToaster(props.deleteErrorMessage);
  useToaster(props.deleteModelerErrorMessage);

  useEffect(() => {
    if (!searchParams["runId"]) {
      if (props.activeModeler?.activeModelRunId)
        history.push({
          search: `?runId=${props.activeModeler?.activeModelRunId}`,
        });
    }
  }, [searchParams, props.activeModeler, props.onFetchModelRunById]);

  useEffect(() => {
    if (props.modelRunCreateSuccess && props.selectedModelRun?.id) {
      history.push({
        search: `?runId=${props.selectedModelRun?.id}`,
      });
    }
  }, [props.modelRunCreateSuccess]);

  useEffect(() => {
    const runId = searchParams["runId"];
    if (runId) {
      props.onFetchModelRunById(runId);
    }
  }, [searchPart, props.activeModeler, props.activeModeler?.activeModelRunId]);

  useEffect(() => {
    props.resetModelRunState();
    if (props.deleteModelerStatus === GLOBAL_CONSTANTS.REQUEST_STATUS.SUCCESS) {
      history.push("/modelers/managed");
    }
  }, [props.deleteModelerStatus]);

  useEffect(() => {
    props.resetModelRunState();
    props.onFectchModelerById(modelerId);
  }, [modelerId, props.onFectchModelerById]);

  function onNewButtonClick() {
    props.oncreateNewModelRun(props.activeModeler);
  }

  function onUploadClick() {
    setIsUploadModalOpen(true);
  }
  function close() {
    setIsUploadModalOpen(false);
  }

  if (props.isLoading) {
    return (
      <>
        <SubHeader></SubHeader>
        <MessageContainer>
          {/* You can replace the following line with your own LoadingComponent */}
          <ExtraLargeSpinner></ExtraLargeSpinner>
        </MessageContainer>
      </>
    );
  }

  if (props.fetchError) {
    return (
      <>
        <SubHeader></SubHeader>
        <MessageContainer>
          <FetchErrorComponent
            onRefresh={() => props.onFectchModelerById(modelerId)}
            message={props.fetchErrorMessage}
          />
        </MessageContainer>
      </>
    );
  }
  return (
    <Fragment>
      <Block>
      <ModelerSubHeaderView
        onUploadClick={onUploadClick}
        hasActiveRun={searchParams["runId"] !== null}
      ></ModelerSubHeaderView>
      {props.activeModeler?.templateId &&
      (<Notification
        kind={KIND.info}
        closeable
        overrides={{
          Body: {
            style: ({ $theme }) => {
              return {
                width: "95%",
                // backgroundColor: $theme.colors.positive,
              };
            },
          },
        }}
      >
        {()=>"Please be aware that this modeler was created from a template and can only be altered or removed through the original template it was derived from."}
      </Notification>)}
      </Block>
      <UploadModalComponent isOpen={isUploadModalOpen} close={close} />

      <MainContainer>
        <SidebarArea span={[1, 2, 2]}>
          <Button
            startEnhancer={<Plus size={24} />}
            $style={{
              width: "200px",
              borderRadius: "25px",
              margin: "15px 5px",
            }}
            onClick={() => {
              onNewButtonClick();
            }}
          >
            New Run{" "}
          </Button>
          <ModelerExecuteSidebarView
            onSelectedChanged={(itemId) => setActiveItemId(itemId)}
            items={MAIN_SIDEBAR_ITEMS}
          />
        </SidebarArea>
        <MainArea span={[2, 4, 7]}>
          <Route
            path={`${ROUTES_PATH.modelerExecute}:modelerId/${ROUTES_PATH.modelerExecuteHome}`}
          >
            <ModelerExecuteHomeView />
          </Route>
          <Route
            path={`${ROUTES_PATH.modelerExecute}:modelerId/${ROUTES_PATH.modelerExecuteHistory}`}
          >
            <ModelerHistorySummary setActiveRun={props.onSetselectedModelRun} />
          </Route>
          <Route
            path={`${ROUTES_PATH.modelerExecute}:modelerId/${ROUTES_PATH.modelerExecuteGallery}`}
          >
            <ModelerDocumentationView
              modelRunId={searchParams["runId"]}
              activeModelRun={props.selectedModelRun}
              onUploadClick={onUploadClick}
            />
          </Route>
          <Route
            path={`${ROUTES_PATH.modelerExecute}:modelerId/${ROUTES_PATH.modelerExecuteTasks}`}
          >
            <ModelerRunExecutions
              fetchInProgress={props.isLoadingModeler}
              modelRuns={props.modelRuns}
              fetchErrorMessage={props.errors}
              nextToken={props.nextToken}
              onFetchModelRunsByModelerId={props.onFetchModelRunById}
              onDeleteModelRunById={props.onDeleteModelRunById}
            />
          </Route>
          <Route
            path={`${ROUTES_PATH.modelerExecute}:modelerId/${ROUTES_PATH.modelerPostProcessing}`}
          >
            <ModelerPostProcessingView
              fetchInProgress={props.isLoadingModeler}
              modelRuns={props.modelRuns}
              fetchErrorMessage={props.errors}
              nextToken={props.nextToken}
              onFetchModelRunsByModelerId={props.onFetchModelRunById}
              onDeleteModelRunById={props.onDeleteModelRunById}
            />
          </Route>
          <Route
            path={`${ROUTES_PATH.modelerExecute}:modelerId/${ROUTES_PATH.modelerReports}`}
          >
            <ModelerReportsView />
          </Route>          
          <Route>
            <div></div> {/* Default view if none of the paths match */}
          </Route>
        </MainArea>
        <AsideArea span={[1, 2, 3]}>
          <ModelerPropertiesAsideView />
        </AsideArea>
      </MainContainer>
    </Fragment>
  );
}

const mapStateToProps = (state) => {
  return {
    activeModeler: state.modeler.activeModeler,
    isLoadingModeler: state.modeler.isLoading,
    modelRuns: state.modelRun.modelRuns,
    selectedModelRun: state.modelRun.selectedModelRun,
    errors: state.modelRun.errors,
    fetchError: state.modeler.activeModeler?.fetchError,
    fetchErrorMessage: state.modeler.activeModeler?.fetchErrorMessage,
    isLoading: state.modeler.activeModeler?.isLoading,
    activeModelRunId: state.modelRun.activeModelRunId,
    updateInProgress: state.modelRun.updateInProgress,
    modelRunCreateSuccess: state.modelRun.createSuccess,
    updateError: state.modelRun.updateError,
    updateErrorMessage: state.modelRun.updateErrorMessage,
    deleteModelerStatus: state.modeler.deleteStatus,
    deleteModelRunStatus: state.modelRun.deleteModelRunStatus,
    deleteError: state.modelRun.deleteError,
    deleteErrorMessage: state.modelRun.deleteErrorMessage,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onFectchModelerById: (id) => {
      dispatch(fetchModelerById(id));
    },
    oncreateNewModelRun: (activeModeler) => {
      dispatch(createNewModelRun(activeModeler));
    },
    onSetselectedModelRun: (modelrunId) => {
      dispatch(setselectedModelRun(modelrunId));
    },
    onFetchModelRunById: (modelerId) => {
      dispatch(fetchModelRunById(modelerId));
    },
    oncreateModelRunAsset: (modelerId, modelRunId, fileType, file) => {
      dispatch(createModelRunAsset(modelerId, modelRunId, fileType, file));
    },
    resetModelRunState: () => {
      dispatch(resetModelRunState());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ModelerExecuteView);
